import React from "react";

function LoopButton({ onClick, isLooped }) {
  return (
    <div
      onClick={onClick}
      className={`${
        isLooped ? "text-blue-500" : " text-slate-300"
      } text-[20px] relative`}
    >
      <i className="bi-arrow-repeat"></i>
      <span className="absolute left-0 -bottom-[12px]">
        <i className="bi-dot"></i>
      </span>
    </div>
  );
}

export default LoopButton;
